import React from 'react';
import PropTypes from 'prop-types';

import MenuToggler from '../menu-toggler';
import { MenuLinkAction } from '../menu/MenuLinkAction.view';
import { MenuAction } from '../menu/MenuAction.view';
import { confirmBefore } from '../../utils/common.utils';
import MenuIcon from '../../images/icons/menu.svg';

import './style.css';
import { TestID } from 'src/testID';

class SystemActionsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { actionParameter: '' };
  }

  render() {
    const menuIcon = <MenuIcon className="system-actions-menu" />;

    return (
      <MenuToggler label={menuIcon} labelClassName="system-actions-menu__toggler">
        <MenuLinkAction
          label="Duplicate"
          to={`/subscription/${this.props.subId}/systems/new/${this.props.system._id}`}
        />
        <MenuAction
          label="Delete"
          onClick={() =>
            confirmBefore('Are you sure you want to delete this system?', () =>
              this.props.onDelete([this.props.system._id])
            )
          }
          testId={TestID.DeleteSystem}
        />
      </MenuToggler>
    );
  }
}

SystemActionsMenu.propTypes = {
  onDelete: PropTypes.func.isRequired,
  system: PropTypes.object.isRequired,
  subId: PropTypes.string.isRequired,
};

export default SystemActionsMenu;
